import { config } from "../../stateManagement/redux/configVar"
import { formatDateToYYYYMMDD } from "../../shared/util/formatDates"
import { projectList } from "../../shared/util/projectList"

export interface MessageSummary {
    cuadrilla: string,
    integrantes: string,
    tecnologia: string,
    pozos_visitados: string,
    pozos_aportando: string,
    pozos_sin_aporte: string,
    pozos_operando: string,
    pozos_IT: string,
    pozos_sin_acceso: string,
    pozos_recolocado: string,
    pozos_en_observacion: string,
    pozos_reespaceados: string,
    pozos_restaurados: string,
    pozos_sin_produccion: string,
    produccion_monitoreado: string,
    produccion_diferida: string,
    produccion_restaurada: string,
    cartas_realizadas: string,
    estudios_echometer: string,
    muestras: string,
}


export const getSummary = (sortActivities: any[], setSummary: any, executedDate: any, setWsMessage: any) => {


    const integrantes = sortActivities[0].users.map((user: any) => user.name).join(', ')

    const cuadrilla = sortActivities[0].variables.find((v: any) => v.name === "Cuadrilla")?.value

    const tecnologia = sortActivities[0].variables.find((v: any) => v.name === "Tecnologia")?.value

    const pozos_visitados = sortActivities.length

    const pozos_aportando = sortActivities.filter((activity: any) => {
        const final_state = activity.variables.find((v: any) => v.name === "Estado Pozo Final")?.value

        if (final_state === "Aportando" || final_state === "Restaurado") {
            return true
        }

        return false
    })

    const pozos_operando = sortActivities.filter((activity: any) => {
        const final_state = activity.variables.find((v: any) => v.name === "Estado Pozo Final")?.value

        if (final_state === "Operando") {
            return true
        }

        return false
    })

    const pozos_en_observacion = sortActivities.filter((activity: any) => {
        const final_state = activity.variables.find((v: any) => v.name === "Estado Pozo Final")?.value

        if (final_state === "Observación") {
            return true
        }

        return false
    })

    const pozos_sin_aporte = sortActivities.filter((activity: any) => {
        const final_state = activity.variables.find((v: any) => v.name === "Estado Pozo Final")?.value

        if (final_state === "Sin Aporte") {
            return true
        }

        return false
    })


    const pozos_sin_produccion = sortActivities.filter((activity: any) => {
        const final_state = activity.variables.find((v: any) => v.name === "Estado Pozo Final")?.value

        if (final_state === "Sin Producción") {
            return true
        }

        return false
    })


    const pozos_it = sortActivities.filter((activity: any) => {
        const final_state = activity.variables.find((v: any) => v.name === "Estado Pozo Final")?.value

        if (final_state === "IT") {
            return true
        }

        return false
    })

    const pozos_sin_acceso = sortActivities.filter((activity: any) => {
        const final_state = activity.variables.find((v: any) => v.name === "Estado Pozo Final")?.value

        if (final_state === "Sin Acceso") {
            return true
        }

        return false
    })

    const pozos_restaurados = sortActivities.filter((activity: any) => {
        const final_state = activity.variables.find((v: any) => v.name === "Estado Pozo Final")?.value

        if (final_state === "Restaurado") {
            return true
        }

        return false
    })

    const pozos_reespaceados = sortActivities.filter((activity: any) => {
        const final_state = activity.variables.find((v: any) => v.name === "Reespaceo")?.value

        if (final_state === "true") {
            return true
        }

        return false
    })

    const pozos_recolocado = sortActivities.filter((activity: any) => {
        const initial_state = activity.variables.find((v: any) => v.name === "Estado Pozo Inicial")?.value
        const final_state = activity.variables.find((v: any) => v.name === "Estado Pozo Final")?.value

        if (initial_state == "IT" && final_state === "Aportando") {
            return true
        }

        return false
    })

    const cartas_realizadas = sortActivities.filter((activity: any) => {
        const value = activity.variables.find((v: any) => v.name === "Tipo Actividad")?.value

        if (value === "Carta Leuter" || value === "Carta Dinagrafica") {
            return true
        }

        return false
    })

    const estudios_echometer = sortActivities.filter((activity: any) => {
        const tecnologia = activity.variables.find((v: any) => v.name === "Tecnologia")?.value

        const carta = activity.variables.find((v: any) => v.name === "Carta")?.value

        const nivel = activity.variables.find((v: any) => v.name === "Nivel")?.value

        if (tecnologia === "Echometer" && (carta==='true' || nivel==='true')) {
            return true
        }

        return false
    })

    const produccion_monitoreado = sortActivities.reduce((acc, activity) => {

        const value = activity.variables.find((v: any) => v.name === "POT")?.value

        if (typeof acc !== "number") {
            return isNaN(parseInt(value)) ? 0 : parseInt(value)
        }

        const pot = isNaN(parseInt(value)) ? 0 : parseInt(value)

        return acc + pot
    }, 0)

    const produccion_restaurada = pozos_restaurados.reduce((acc, activity) => {
        const value = activity.variables.find((v: any) => v.name === "POT")?.value

        if (typeof acc !== "number") {
            return isNaN(parseInt(value)) ? 0 : parseInt(value)
        }

        const pot = isNaN(parseInt(value)) ? 0 : parseInt(value)

        return acc + pot
    }, 0)

    const produccion_it = pozos_it.reduce((acc, activity) => {
        const value = activity.variables.find((v: any) => v.name === "POT")?.value

        if (typeof acc !== "number") {
            return isNaN(parseInt(value)) ? 0 : parseInt(value)
        }

        const pot = isNaN(parseInt(value)) ? 0 : parseInt(value)

        return acc + pot
    }, 0)

    const produccion_sin_apporte = pozos_sin_aporte.reduce((acc, activity) => {
        const value = activity.variables.find((v: any) => v.name === "POT")?.value

        if (typeof acc !== "number") {
            return isNaN(parseInt(value)) ? 0 : parseInt(value)
        }

        const pot = isNaN(parseInt(value)) ? 0 : parseInt(value)

        return acc + pot
    }, 0)

    const muestras = sortActivities.filter((activity: any) => {
        const value = activity.variables.find((v: any) => v.name === "Muestras")?.value

        if (value === "true") {
            return true
        }

        return false
    })

    const produccion_diferida = produccion_it + produccion_sin_apporte

    const summary: MessageSummary = {
        cuadrilla,
        integrantes,
        tecnologia,
        pozos_visitados: `${pozos_visitados}`,
        pozos_aportando: `${pozos_aportando?.length}`,
        pozos_operando: `${pozos_operando?.length}`,
        pozos_sin_aporte: `${pozos_sin_aporte?.length}`,
        pozos_IT: `${pozos_it?.length}`,
        pozos_sin_acceso: `${pozos_sin_acceso?.length}`,
        pozos_recolocado: `${pozos_recolocado?.length}`,
        pozos_en_observacion: `${pozos_en_observacion?.length}`,
        pozos_reespaceados: `${pozos_reespaceados?.length}`,
        pozos_restaurados: `${pozos_restaurados?.length}`,
        pozos_sin_produccion: `${pozos_sin_produccion?.length}`,
        produccion_monitoreado: `${produccion_monitoreado} BNPD`,
        produccion_diferida: `${produccion_diferida} BNPD`,
        produccion_restaurada: `${produccion_restaurada} BNPD`,
        cartas_realizadas: `${cartas_realizadas?.length}`,
        estudios_echometer: `${estudios_echometer?.length}`,
        muestras: `${muestras.length}`
    }

    const campo = projectList.find((p) => p.projectId === sortActivities[0].projectId)?.name

    const ws_message = `
*Tipo de actividad*: ${tecnologia}
*Fecha*: ${formatDateToYYYYMMDD(executedDate)}
*Campo*: ${campo}
*# Cuadrilla*: ${summary.cuadrilla}
*Integrantes*: ${summary.integrantes}
*Pozos visitados*: ${summary.pozos_visitados}
*Pozos Aportando*: ${summary.pozos_aportando}
*Pozos operando*: ${summary.pozos_operando}
*Pozos sin aporte*: ${summary.pozos_sin_aporte}
*Pozos IT*: ${summary.pozos_IT}
*Pozos sin acceso*: ${summary.pozos_sin_acceso}
*Pozos recolocado*: ${summary.pozos_recolocado}
*Pozos en observación*: ${summary.pozos_en_observacion}
*Pozos reespaceados*: ${summary.pozos_reespaceados}
*Pozos sin producción*: ${summary.pozos_sin_produccion}
*Producción asociada*: ${summary.produccion_monitoreado}
*Producción diferida*: ${summary.produccion_diferida} BN
*Producción restaurada*: ${summary.produccion_restaurada} BN
*Cartas realizadas*: ${summary.cartas_realizadas}
*Estudios Echometer*: ${summary.estudios_echometer}
    `

    setSummary(summary)

    setWsMessage(ws_message)
}

export interface SummaryActivities {
    [key: string]: {
        name: string;
        actividadPlanificada?: string[];
        pozosVisitados: number;
        pozosAportando?: number;
        pozosSinAporte?: number;
        pozosOperando?: number;
        pozosIT?: number;
        pozosSinAcceso?: number;
        pozosRecolocado?: number;
        pozosEnObservacion?: number;
        pozosReespaceados?: number;
        pozosSinProduccion?: number
        pozosRestaurados?: number;
        produccionMonitoreado?: number;
        produccionDiferida?: number;
        produccionRestaurada?: number;
        cartasRealizadas?: number;
        estudiosCompletos?: number;
    };
}
export interface LocationWithoutProduction {
    locationId: string;
    locationName: string;
    field: string;
    groupAssigned: string;
    locationFinalState: string;
    comment: string;
    conditionSummary: string;
    responsible: string;
}
